module.exports = __webpack_public_path__ + "img/744.4d8efb13.jpg";